import { Component, OnInit } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';
import {BehaviorSubject} from "rxjs";
import {IDepartment} from "../../setting/models/departement";
import {AppNotificationService} from "../services/notification.service";

export interface INotification {
  message: string,
  style: 'success' | 'error',
}

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.css'],
    providers: [NotificationService],
    standalone: false
})

export class NotificationComponent implements OnInit{


  constructor(
    private notificationService: NotificationService,
    private appnotificationService: AppNotificationService) {
  }

  private notification$: BehaviorSubject<INotification> =
    this.appnotificationService.notification$

  private hideAfter = 3000;

  ngOnInit() {
    this.notification$
      .subscribe(notification => {
        console.log(notification, "new sub");
        if (notification){
          this.showNotification(notification)
        }
      })
  }

  private showNotification(notification: INotification): void {
    console.log(notification, "create new notification");
    this.notificationService.show({
      content: notification.message,
      cssClass: "button-notification",
      animation: { type: "fade", duration: 400 },
      position: { horizontal: "center", vertical: "top" },
      type: { style: notification.style, icon: true },
      hideAfter: this.hideAfter,
    });
  }

}
